import React from 'react';
import MainGame from "./MainGame";

function App() {
  return (
    <MainGame />
  )
}

export default App;
